import { render } from "./GeoFencingEventsModal.vue?vue&type=template&id=1353fb8c&ts=true"
import script from "./GeoFencingEventsModal.vue?vue&type=script&lang=ts"
export * from "./GeoFencingEventsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__